/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useQuery } from '@/hooks/query.hook';
import { PageURLs } from '@/utils/navigate';
import { Typography, Button as ButtonAnt } from 'antd';
import { Icon } from '../../components/icons';
import { useAppDispatch } from '@/redux/hooks';
import { getListOptions } from '@/redux/slices/options.slice';
import { useEffect } from 'react';
import { ChatGPTCreateForm } from '@/components/forms/chatGPT-management-create.form';

export const ChatGPTCreate = () => {
  const { push } = useQuery();
  const dispatch = useAppDispatch();
  const handleGoBack = () => {
    push(PageURLs.ofChatGPT());
  };

  useEffect(() => {
    dispatch(getListOptions({ code: 'PLAT_FORM' }));
  }, [dispatch]);

  return (
    <div css={rootStyles}>
      <div css={boxStyles}>
        <Typography.Title css={titleStyles} level={5}>
          <ButtonAnt
            css={goBackBtnStyles}
            onClick={handleGoBack}
            type='text'
            icon={<Icon type='arrowLeft' width={20} height={20} />}
          />
          Thêm mới câu hỏi
        </Typography.Title>
      </div>
      <div>
        <ChatGPTCreateForm handleGoBack={handleGoBack} />
      </div>
    </div>
  );
};

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 3.2rem;
  }
`;

const titleStyles = css`
  display: flex;
  gap: 0.6rem;
  align-items: center;
  position: relative;
  left: 2rem;
  margin-bottom: 0 !important;
`;

const goBackBtnStyles = css`
  position: absolute;
  left: -3rem;
  width: 2.6rem !important;
  height: 2.6rem !important;
  padding: 0;
  svg {
    margin-top: 0.1rem;
  }
  &:hover {
    border-radius: 50%;
  }
`;
